<profile-ingot>
  <ng-container image>
    <partner-avatar
      [partner]="partner"
      [width]="100"
      [height]="40"
      [alt]="partner.name"
    ></partner-avatar>
  </ng-container>

  <a [routerLink]="partner | partnerLink" tabindex="-1">{{ partner.name }}</a>
</profile-ingot>
